export const regexPatterns = {
  arrayDelimiter: /[,\s]+/,
  email: /^[a-zA-Z0-9.!#$%&’*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  middleInitial: /^([a-z])?([A-Z])?$/,
  name: /^[a-zA-Z ,.'-]+$/,
  password: /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&+=*]).*/,
  suffix: /^[a-zA-Z\\.]+$/,
  pin: /^[ a-zA-Z0-9-\.!#$%&'*+/=?^_`{|}~]*$/,
  ssn4: /^\d{4}$/,
  address: /^[ a-zA-Z0-9-\:,\'.#;_]*$/,
  zipCode: /^\d{5}?(-\d{4})?$/,
  number: /^\d+$/,
  runHistoryMonths: /^(\d{0,3}|1000)$/,
  additionalFilters: /^[ a-zA-Z0-9-,\'._]*$/,
  queryName: /^[ a-zA-Z0-9-,\'._\:#;+\/]*$/,
  alphaNumericString: /^[ a-zA-Z0-9-\'_.]*$/,
  alphaNumeric: /^[a-z\d\-_\s]+$/,
  initialWhiteSpace: /^[^ ](.)*$/
};
